<template>
  <div v-if="show" class="mt-4">
    <content-loading v-if="isLoading" />
    <span v-else-if="recommendations && recommendations.docs && recommendations.docs.length">
      <hr />
      <h4>{{ title ? title : $t("common.recommendations") }}</h4>
      <div class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in recommendations.docs" :key="'recommendation-box-' + item._id" class="ds-card--item2">
          <div class="text">
            {{ item.name | translate }}
            <br />
            <br />
            <i class="bx bx-pencil hand mr-3" @click="copyToForm(item)" v-b-tooltip.hover :title="$t('common.save-as')"></i>
            <i class="bx bx-plus hand" @click="addFromLibrary(item)" v-b-tooltip.hover :title="$t('common.add-to-organization')"></i>
          </div>
        </div>
      </div>

      <!-- Begin: Pagination  -->

      <div class="row mt-3">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="recommendationRequest.options.page"
              :total-rows="recommendations.totalDocs"
              :per-page="recommendations.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
      <!--   End: Pagination -->
    </span>
  </div>
</template>

<script>
export default {
  props: ["query", "organizationScopedState", "libraryScopedState", "level", "id", "show", "title"],
  data() {
    return {
      recommendationRequest: {
        options: { page: 1, limit: 14 },
        query: {},
      },
    };
  },
  watch: {
    recommendationRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounceMixin(() => this.fetchRecommendation());
      },
    },
    recommendations() {
      if (!this.recommendations?.docs?.length) {
        this.show = false;
      }
    },
    id() {
      this.debounceMixin(() => this.fetchRecommendation());
    },
  },
  computed: {
    recommendations() {
      return this.$store.getters[`${this.libraryScopedState}/recommendations`];
    },
    isLoading() {
      return this.$store.getters[`${this.libraryScopedState}/isLoading`];
    },
  },
  mounted() {},
  methods: {
    fetchRecommendation() {
      this.$store.dispatch(`${this.libraryScopedState}/paginateRecommendation`, {
        pagination: { ...this.recommendationRequest, query: { ...this.recommendationRequest.query, ...this.query } },
        level: this.level,
        id: this.id,
      });
    },

    async addFromLibrary(libraryItem) {
      try {
        const payload = {
          libraryItem,
        };
        this.$emit("interceptForSetParent", payload);
        await this.$store.dispatch(`${this.organizationScopedState}/addFromLibrary`, payload);
        this.$toast.success(this.$t("common.success"));
        this.$emit("onAccepted", libraryItem);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    copyToForm(item) {
      this.$emit("copyToForm", item);
    },
  },
};
</script>

<style></style>
